export default __webpack_public_path__ + "static/media/nigeria.0e782d6e.webp";